export function createAtlAttributionHeaderValue({
	atlWorkspaceId,
	tenantId,
	product,
}: {
	atlWorkspaceId: string;
	tenantId: string;
	product: string;
}) {
	const atlAttributionHeader = {
		atlWorkspaceId,
		tenantId,
		product,
	};
	return JSON.stringify(atlAttributionHeader);
}
